module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "reservationIndex"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v(_vm._s(_vm.headTitle))]), _vm._v(" "), _c('grid', {
    staticClass: "menuList",
    attrs: {
      "show-lr-borders": false
    }
  }, [_c('grid-item', [_c('li', {
    class: {
      gridSelect: _vm.pageTpe == 'all'
    },
    on: {
      "click": function($event) {
        _vm.menuClick('all')
      }
    }
  }, [_c('div', {
    staticClass: "icon",
    staticStyle: {
      "background-image": "linear-gradient(to right,#fccc56,#faa72c)"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-jianchajieguo"
  })]), _vm._v(" "), _c('p', [_vm._v("已预约")])])]), _vm._v(" "), _c('grid-item', [_c('li', {
    class: {
      gridSelect: _vm.pageTpe == 'jc'
    },
    on: {
      "click": function($event) {
        _vm.menuClick('jc')
      }
    }
  }, [_c('div', {
    staticClass: "icon",
    staticStyle: {
      "background-image": "linear-gradient(to right,#fe9e7e,#fe6259)"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-jiancha_o",
    staticStyle: {
      "font-size": "20px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("B超/抽血")])])]), _vm._v(" "), _c('grid-item', [_c('li', {
    class: {
      gridSelect: _vm.pageTpe == 'zs'
    },
    on: {
      "click": function($event) {
        _vm.menuClick('zs')
      }
    }
  }, [_c('div', {
    staticClass: "icon",
    staticStyle: {
      "background-image": "linear-gradient(to right,#7cccfc,#5a91fd)"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-zhushe"
  })]), _vm._v(" "), _c('p', [_vm._v("注射预约")])])]), _vm._v(" "), _c('grid-item', [_c('li', {
    class: {
      gridSelect: _vm.pageTpe == 'qt'
    },
    on: {
      "click": function($event) {
        _vm.menuClick('qt')
      }
    }
  }, [_c('div', {
    staticClass: "icon",
    staticStyle: {
      "background-image": "linear-gradient(to right,#fccc56,#faa72c)"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-jilu"
  })]), _vm._v(" "), _c('p', [_vm._v("其他预约")])])])], 1)], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageTpe == 'all'),
      expression: "pageTpe =='all'"
    }],
    staticClass: "allcontent appcontent paddingTop45"
  }, [_c('divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allyyytableData.today.length != 0),
      expression: "allyyytableData.today.length !=0"
    }],
    staticStyle: {
      "margin": "5px 10px 0"
    }
  }, [_vm._v("当日行程单")]), _vm._v(" "), _vm._l((_vm.allyyytableData.today), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.orderStatus == 2) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("已签到")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rightTtem"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.SCHENAME || item.itemName || item.orderName))]), _vm._v(" "), _c('div', {
      staticClass: "contant"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v("预约时间：")]), _vm._v(_vm._s(item.orderDate) + "   " + _vm._s(item.shiftTime))]), _vm._v(" "), _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("地点：")]), _vm._v(_vm._s(item.schePlace))]), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("签到号码：")]), _vm._v(_vm._s(item.signNum))]) : _vm._e(), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("当前叫号：")]), _vm._v(_vm._s(item.nowjzh))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "operanBtn"
    }, [(item.canUpdate == 1) ? _c('div', {
      staticClass: "one",
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_vm._v("修改预约")]) : _vm._e(), _vm._v(" "), (item.canOrder == 1 && item.orderStatus != 2) ? _c('div', {
      staticClass: "two",
      on: {
        "click": function($event) {
          _vm.cancelReservation(item)
        }
      }
    }, [_vm._v("取消预约")]) : _vm._e(), _vm._v(" "), (item.orderStatus == 1 && item.canSign == 1) ? _c('div', {
      staticClass: "three",
      on: {
        "click": function($event) {
          _vm.register(item.location, item, item.orderDate)
        }
      }
    }, [_vm._v("签到")]) : _vm._e()])])])
  }), _vm._v(" "), _c('divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allyyytableData.other.length != 0),
      expression: "allyyytableData.other.length !=0"
    }],
    staticStyle: {
      "margin": "5px 10px 0"
    }
  }, [_vm._v("其他时间行程单")]), _vm._v(" "), _vm._l((_vm.allyyytableData.other), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.orderStatus == 2) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("已签到")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rightTtem"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.SCHENAME || item.itemName || item.orderName))]), _vm._v(" "), _c('div', {
      staticClass: "contant"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v("预约时间：")]), _vm._v(_vm._s(item.orderDate) + "   " + _vm._s(item.shiftTime))]), _vm._v(" "), _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("地点：")]), _vm._v(_vm._s(item.schePlace))]), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("签到号码：")]), _vm._v(_vm._s(item.signNum))]) : _vm._e(), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("当前叫号：")]), _vm._v(_vm._s(item.nowjzh))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "operanBtn"
    }, [(item.canUpdate == 1) ? _c('div', {
      staticClass: "one",
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_vm._v("修改预约")]) : _vm._e(), _vm._v(" "), (item.canOrder == 1 && item.orderStatus != 2) ? _c('div', {
      staticClass: "two",
      on: {
        "click": function($event) {
          _vm.cancelReservation(item)
        }
      }
    }, [_vm._v("取消预约")]) : _vm._e(), _vm._v(" "), (item.orderStatus == 1 && item.canSign == 1) ? _c('div', {
      staticClass: "three",
      on: {
        "click": function($event) {
          _vm.register(item.location, item, item.orderDate)
        }
      }
    }, [_vm._v("签到")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.allyyytableData.today.length == 0 && _vm.allyyytableData.other.length == 0) ? _c('div', {
    staticClass: "nodata"
  }, [_c('div', {
    staticClass: "iconfont icon-wushuju"
  }), _c('p', [_vm._v("暂无已预约！")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageTpe != 'all'),
      expression: "pageTpe !='all'"
    }],
    staticClass: "bg myappointment"
  }, [(_vm.pageTpe != 'all') ? _c('tab', {
    staticClass: "tabHeader",
    attrs: {
      "active-color": "#4ba7e8",
      "bar-active-color": "#4ba7e8",
      "prevent-default": ""
    },
    on: {
      "on-before-index-change": _vm.HeaderswitchTab
    },
    model: {
      value: (_vm.bigTabIndex),
      callback: function($$v) {
        _vm.bigTabIndex = $$v
      },
      expression: "bigTabIndex"
    }
  }, _vm._l((_vm.tabTitle), function(item, index) {
    return _c('tab-item', {
      key: index,
      attrs: {
        "selected": index == _vm.bigTabIndex
      }
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content appcontent"
  }, [(_vm.bigTabIndex == 0 && _vm.pageTpe != 'all') ? _c('div', {
    staticClass: "tabcontent"
  }, [_c('ul', _vm._l((_vm.dyytableData), function(item, index) {
    return _c('li', {
      key: index
    }, [(_vm.pageTpe == 'zy') ? _c('check-icon', {
      staticClass: "buleCheckIcon",
      attrs: {
        "value": item.checked
      },
      on: {
        "update:value": function($event) {
          _vm.$set(item, "checked", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rightTtem",
      class: {
        CheckIconright: _vm.pageTpe == 'zy'
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(item.itemName || item.orderName) + "\n                "), (item.payStatus == 1) ? _c('span', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v("已缴费")]) : _vm._e(), _vm._v(" "), (item.payStatus == 2) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("未缴费")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "contant"
    }, [(_vm.pageTpe == 'zy') ? _c('div', [_c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v("申请单号：")]), _vm._v(_vm._s(item.applicationNo))]), _vm._v(" "), _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("开单日期：")]), _vm._v(_vm._s(item.orderDate))]), _vm._v(" "), _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("剩余次数：")]), _vm._v(_vm._s(item.remainTimes))])]) : _vm._e(), _vm._v(" "), (_vm.pageTpe == 'jc') ? _c('div', [_c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v("开单日期：")]), _vm._v(_vm._s(item.reqDate))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "operanBtn"
    }, [(_vm.pageTpe != 'zy' && item.canOrder != 2) ? _c('div', {
      staticClass: "one",
      on: {
        "click": function($event) {
          _vm.reservation(item)
        }
      }
    }, [_vm._v("立即预约")]) : _vm._e(), _vm._v(" "), (item.canOrder == 2) ? _c('p', [_vm._v("该项目仅支持到院诊间预约")]) : _vm._e()])])], 1)
  })), _vm._v(" "), (_vm.dyytableData.length == 0) ? _c('div', {
    staticClass: "nodata"
  }, [_c('div', {
    staticClass: "iconfont icon-wushuju"
  }), _c('p', [_vm._v("暂无数据！")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bigTabIndex == 1 && _vm.pageTpe != 'all') ? _c('ul', [_vm._l((_vm.yyytableData), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.orderStatus == 2) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("已签到")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rightTtem"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.SCHENAME || item.itemName || item.orderName))]), _vm._v(" "), _c('div', {
      staticClass: "contant"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('span', [_vm._v("预约时间：")]), _vm._v(_vm._s(item.orderDate) + "   " + _vm._s(item.shiftTime))]), _vm._v(" "), _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("地点：")]), _vm._v(_vm._s(item.schePlace))]), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("签到号码：")]), _vm._v(_vm._s(item.signNum))]) : _vm._e(), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('span', [_vm._v("当前叫号：")]), _vm._v(_vm._s(item.nowjzh))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "operanBtn"
    }, [(item.canUpdate == 1) ? _c('div', {
      staticClass: "one",
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_vm._v("修改预约")]) : _vm._e(), _vm._v(" "), (item.canOrder == 1 && item.orderStatus != 2) ? _c('div', {
      staticClass: "two",
      on: {
        "click": function($event) {
          _vm.cancelReservation(item)
        }
      }
    }, [_vm._v("取消预约")]) : _vm._e(), _vm._v(" "), (item.orderStatus == 1 && item.canSign == 1) ? _c('div', {
      staticClass: "three",
      on: {
        "click": function($event) {
          _vm.register(item.location, item, item.orderDate)
        }
      }
    }, [_vm._v("签到")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.yyytableData.length == 0) ? _c('div', {
    staticClass: "nodata"
  }, [_c('div', {
    staticClass: "iconfont icon-wushuju"
  }), _c('p', [_vm._v("暂无数据！")])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bigTabIndex == 0 && _vm.personInfoId != '' && _vm.pageTpe == 'zy' && _vm.dyytableData.length > 0),
      expression: "bigTabIndex ==0 && personInfoId !='' && pageTpe == 'zy' && dyytableData.length >0"
    }],
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "42px",
      "margin": "0 0 0 5px",
      "width": "100px",
      "line-height": "42px",
      "color": "#666"
    }
  }, [(_vm.pageTpe == 'zy') ? _c('check-icon', {
    staticClass: "buleCheckIcon",
    attrs: {
      "value": _vm.allChecked
    },
    on: {
      "update:value": function($event) {
        _vm.allChecked = $event
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.allCheckedChoose($event)
      }
    }
  }) : _vm._e(), _vm._v("\n          全选\n        ")], 1), _vm._v(" "), _c('x-button', {
    staticClass: "generalBtn orangeBtn",
    nativeOn: {
      "click": function($event) {
        _vm.reservationZYClick($event)
      }
    }
  }, [_vm._v("预约")])], 1), _vm._v(" "), _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bigTabIndex == 0 && _vm.personInfoId != '' && _vm.pageTpe == 'zs'),
      expression: "bigTabIndex ==0 && personInfoId !='' && pageTpe == 'zs'"
    }],
    staticClass: "generalBtn orangeBtn",
    nativeOn: {
      "click": function($event) {
        _vm.$router.push({
          path: '/reservationInjection',
          query: {
            personInfoId: _vm.personInfoId,
            openid: _vm.openid
          }
        })
      }
    }
  }, [_vm._v("新增注射预约")]), _vm._v(" "), _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bigTabIndex == 0 && _vm.personInfoId != '' && _vm.pageTpe == 'qt'),
      expression: "bigTabIndex ==0 && personInfoId !='' && pageTpe == 'qt'"
    }],
    staticClass: "generalBtn orangeBtn",
    nativeOn: {
      "click": function($event) {
        _vm.$router.push({
          path: '/reservationGeneral',
          query: {
            personInfoId: _vm.personInfoId,
            openid: _vm.openid
          }
        })
      }
    }
  }, [_vm._v("新增其他预约")]), _vm._v(" "), _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bigTabIndex == 0 && _vm.personInfoId != '' && _vm.pageTpe == 'ss'),
      expression: "bigTabIndex ==0 && personInfoId !='' && pageTpe == 'ss'"
    }],
    staticClass: "generalBtn orangeBtn",
    nativeOn: {
      "click": function($event) {
        _vm.$router.push({
          path: '/surgicalAppointmentAdd',
          query: {
            personInfoId: _vm.personInfoId,
            openid: _vm.openid
          }
        })
      }
    }
  }, [_vm._v("新增手术预约")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    model: {
      value: (_vm.dialogshow),
      callback: function($$v) {
        _vm.dialogshow = $$v
      },
      expression: "dialogshow"
    }
  }, [(_vm.pageTpe == 'ss') ? _c('div', [_c('div', {
    staticClass: "dialog-demo"
  }, [_c('h2', {
    staticClass: "dialog-title"
  }, [_vm._v("确认取消预约？")]), _vm._v(" "), _c('div', {
    staticClass: "resList"
  }, [_c('checklist', {
    attrs: {
      "title": "请选择取消原因",
      "max": 1,
      "options": _vm.resonList
    },
    model: {
      value: (_vm.inputTxt),
      callback: function($$v) {
        _vm.inputTxt = $$v
      },
      expression: "inputTxt"
    }
  })], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.dialogshow = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialogBtn"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.dialogshow = false;
        _vm.inputTxt = [];
      }
    }
  }, [_vm._v("再考虑一下")]), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.cancelSS
    }
  }, [_vm._v("确 定")])])]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246f2062","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/MyReservationProject/reservationIndex.vue
// module id = zGN3
// module chunks = 7